import Cookie from 'js-cookie'

// Types
import { BrowseState, DisplayMode, QueryResult } from 'types'

export const initialState: BrowseState = {
  displayMode: 'full' as DisplayMode,
  searchconfig: {},
  results: {},
}

type RestLastPageLoaded = {
  type: 'RESET_LAST_PAGE_LOADED'
  data: {
    queryString: string
  }
}

type FetchSerachConfigDone = {
  type: 'FETCH_SEARCH_CONFIG_DONE'
  data: {
    queryString: string
    response: {
      facets: QueryResult
    }
  }
}

type FetchTracksBySearchQueryDone = {
  type: 'FETCH_TRACKS_BY_SEARCH_QUERY_DONE'
  data: {
    queryString: string
    response: QueryResult
    page: number
  }
}

type SetDisplayModeDone = {
  type: 'SET_DISPLAY_MODE'
  data: DisplayMode
}

type BrowsedoneActions = RestLastPageLoaded | FetchSerachConfigDone | FetchTracksBySearchQueryDone | SetDisplayModeDone

export const reducer = (state: BrowseState = initialState, action: BrowsedoneActions) => {
  switch (action.type) {
    case 'RESET_LAST_PAGE_LOADED': {
      const { queryString } = action.data
      return {
        ...state,
        results: {
          ...state.results,
          [queryString]: {
            ...(state.results[queryString] || {}),
            lastPageLoaded: 0,
          },
        },
      }
    }

    case 'FETCH_SEARCH_CONFIG_DONE': {
      const {
        data: {
          queryString,
          response: { facets },
        },
      } = action
      return {
        ...state,
        searchconfig: {
          ...state.searchconfig,
          [queryString]: facets,
        },
      }
    }

    case 'FETCH_TRACKS_BY_SEARCH_QUERY_DONE': {
      const {
        data: {
          queryString,
          response: { result, count },
          page,
        },
      } = action
      const oldTrackIds = state.results[queryString]?.ids
      const mergedSongIds = page === 1 ? result : [...(oldTrackIds || []), ...result]
      return {
        ...state,
        results: {
          ...state.results,
          [queryString]: {
            count,
            lastPageLoaded: page,
            ids: mergedSongIds,
          },
        },
      }
    }

    case 'SET_DISPLAY_MODE':
      Cookie.set('displayMode', action.data)
      return {
        ...state,
        displayMode: action.data,
      }

    default:
      return state
  }
}

export default reducer
